import "./Footer.css";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaWhatsapp,
  FaMapMarkerAlt,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";

function Footer({ mostrarBlog }) {
  const navigate = useNavigate();

  const whatsappNumber = "555135472982";
  const whatsappLink = `https://wa.me/${whatsappNumber}`;
  // console.log(mostrarBlog);

  /*
<p className="dev-credit">
      Desenvolvido por{" "}
      <a
        href="https://github.com/ChristpherFeilstrecker"
        target="_blank"
        rel="noopener noreferrer"
      >
        @CFS
      </a>
    </p>
*/
  return (
    <footer className="footer">
      {/* =====================
          TOPO
      ====================== */}
      <div className="footer-container footer-top">
        <div className="footer-column">
          <h4>Institucional</h4>
          <ul>
            <li onClick={() => navigate("/portalcandidato")}>
              Trabalhe Conosco
            </li>

            <li onClick={() => navigate("/seja-um-representante")}>
              Seja Nosso Representante
            </li>
            <li
              onClick={() =>
                window.open(
                  "/politica-de-privacidade",
                  "_blank",
                  "noopener,noreferrer"
                )
              }
            >
              Política de Privacidade
            </li>
          </ul>
        </div>

        <div className="footer-column">
          <h4>Serviços</h4>
          <ul>
            <li onClick={() => navigate("/quemsomos")}>Quem Somos</li>
            <li onClick={() => navigate("/comocomprar")}>Como Comprar</li>

            {mostrarBlog && (
              <li
                onClick={() =>
                  window.open("/blog-eliandro", "_blank", "noopener,noreferrer")
                }
              >
                Blog
              </li>
            )}
          </ul>
        </div>

        <div className="footer-column">
          <h4>Contato</h4>
          <p>
            <a href={whatsappLink} target="_blank" rel="noopener noreferrer">
              <FaWhatsapp /> <strong>(51) 3547-2982</strong>
            </a>
          </p>

          <p className="endereco">
            <FaMapMarkerAlt />
            R. Leopoldo Franck, 524
            <br />
            Rio Branco, Rolante - RS
            <br />
            95690-000
          </p>
        </div>

        <div className="footer-column">
          <h4>Redes Sociais</h4>
          <div className="social-icons">
            <a
              href="https://www.facebook.com/eliandroalimentosrs/?locale=pt_BR"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook Eliandro Alimentos"
            >
              <FaFacebookF />
            </a>

            <a
              href="https://www.instagram.com/eliandroalimentos/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram Eliandro Alimentos"
            >
              <FaInstagram />
            </a>

            <a
              href="https://br.linkedin.com/company/eliandro-alimentos"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn Eliandro Alimentos"
            >
              <FaLinkedinIn />
            </a>
          </div>
        </div>
      </div>

      {/* =====================
          BOTTOM
      ====================== */}
   <div className="footer-bottom-container">
  <div className="footer-bottom">

    <p className="footer-copy">
  © {new Date().getFullYear()} Eliandro Alimentos. Todos os direitos reservados.

  <span className="footer-separador">
    {" • "}
  </span>

  <span className="dev-credit">
    Desenvolvido por{" "}
    <span className="link-dev">
      @CFS
    </span>
  </span>
</p>

  </div>
</div>
    </footer>
  );
}

export default Footer;
